module.exports = __webpack_public_path__ + "img/IchMachDichMesser.f9bc8c88.svg";